import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { PriceTableComponent } from './price-table/price-table.component';
import { GuildlineComponent } from './guildline/guildline.component';
import { PolicyComponent } from './policy/policy.component';
import { InforComponent } from './infor/infor.component';
import { FooterComponent } from './common/footer/footer.component';
import { HeaderComponent } from './common/header/header.component';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { DetailComponent } from './detail/detail.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { ListMenuProductComponent } from './list-menu-product/list-menu-product.component';
import { ServicesComponent } from './services/services.component';



const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: "home", component: HomeComponent },
  { path: "contact", component: ContactComponent },
  { path: "footer", component: FooterComponent },
  { path: "header", component: HeaderComponent },
  { path: "pricetable", component: PriceTableComponent },
  { path: "guildline", component: GuildlineComponent },
  { path: "policies", component: PolicyComponent },
  { path: "information", component: InforComponent },
  { path: "sidebar", component: SidebarComponent },
  { path: "introduce/:id", component: LandingpageComponent },
  { path: "list-menu-product", component: ListMenuProductComponent },
  { path: "detail", component: DetailComponent },
  { path: "services", component: ServicesComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
